import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeContainer } from "./common/containers/theme/theme.container";
import { StatisticsContainer } from "./common/containers/statistics/statistics.container";
import { FirebaseAuthContainer } from "./common/containers/auth/firebase-auth-container.util";

if (process.env.NODE_ENV === "development") {
    // Dev-only runtime accessibility auditing: @axe-core/react logs axe-core
    // violations to the browser console after each render. The `require`s are
    // gated on NODE_ENV so webpack strips this block (and the dependency) from
    // production builds. Uses the legacy `react-dom` entry, which is what
    // @axe-core/react instruments.
    /* eslint-disable @typescript-eslint/no-var-requires */
    const axe = require("@axe-core/react");
    const React = require("react");
    const ReactDOMLegacy = require("react-dom");
    /* eslint-enable @typescript-eslint/no-var-requires */
    axe(React, ReactDOMLegacy, 1000);
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
    <BrowserRouter>
        <ThemeContainer.Provider>
            <StatisticsContainer.Provider>
                <FirebaseAuthContainer.Provider>
                    <App />
                </FirebaseAuthContainer.Provider>
            </StatisticsContainer.Provider>
        </ThemeContainer.Provider>
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
